/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://t5qswmz6ozgs5dtjyiuikixec4.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2z4c6ehgxjfnno4pjzsd2gbuiy",
    "aws_cognito_identity_pool_id": "us-east-2:d4426bdb-51d3-4a77-867d-ba273f3d7a5c",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_mJxZ5qmBr",
    "aws_user_pools_web_client_id": "57o528b4rhtbl1ebhupqqdlp2j",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
